//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { divTime } from '@/utils';
export default {
  name: 'Index',
  props: {
    formCreateInject: Object,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabled: Boolean,
    timeType: {
      type: String,
      default: function _default() {
        return 'day';
      }
    },
    time: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    titleIpt: {
      type: String,
      default: function _default() {
        return '时长';
      }
    }
  },
  data: function data() {
    return {
      timeNum: this.time,
      options: [{
        value: '1',
        label: '上午'
      }, {
        value: '0',
        label: '下午'
      }],
      timeData: {
        dateStart: this.value.dateStart,
        timeStart: this.value.timeStart,
        dateEnd: this.value.dateEnd,
        timeEnd: this.value.timeEnd,
        duration: this.value.duration,
        timeType: this.timeType
      },
      num: 0,
      title: this.titleIpt
    };
  },
  watch: {
    value: function value(n) {
      this.timeData = n;
    },
    timeType: function timeType(n) {
      this.timeData.timeType = n;
    },
    time: function time(n) {
      this.timeNum = n;
    },
    titleIpt: function titleIpt(n) {
      this.title = n;
    }
  },
  methods: {
    onChange: function onChange() {
      var _this = this;
      var time1 = Date.parse(new Date(this.timeData.dateStart));
      var time2 = Date.parse(new Date(this.timeData.dateEnd));
      if (time1 > time2) {
        return this.$message.error('结束时间不能小于开始时间');
      }
      if (this.timeData.timeType === 'day') {
        if (time2 == time1) {
          setTimeout(function () {
            if (_this.timeData.timeStart === '0' && _this.timeData.timeEnd === '1') {
              return _this.$message.error('结束时间不能小于开始时间');
            }
          }, 200);
        }
        this.num = divTime(this.timeData.dateStart, this.timeData.dateEnd, 'day');
        if (time2 > time1) this.count();
        if (time2 === time1) this.count();
      } else {
        if (time2 > time1) this.timeData.duration = divTime(this.timeData.dateStart, this.timeData.dateEnd, 'time');
      }
    },
    count: function count() {
      if (this.timeData.timeStart && this.timeData.timeEnd) {
        var len = parseFloat(this.timeData.timeStart) - parseFloat(this.timeData.timeEnd);
        if (len === 1) {
          this.timeData.duration = parseFloat(this.num) + 1;
        } else if (len === 0) {
          this.timeData.duration = 0.5 + parseFloat(this.num);
        } else if (len === -1) {
          this.timeData.duration = parseFloat(this.num);
        }
        this.$emit('input', this.timeData);
      }
    },
    onchangeTimeEnd: function onchangeTimeEnd(n) {
      this.timeData.dateEnd = n;
      this.timeData.timeEnd = '1';
      this.onChange();
      this.$emit('input', this.timeData);
    },
    onchangeTimeStart: function onchangeTimeStart(n) {
      this.timeData.dateStart = n;
      this.timeData.timeStart = '1';
      this.onChange();
      this.$emit('input', this.timeData);
    },
    changeDuration: function changeDuration() {
      this.$emit('input', this.timeData);
    },
    onchangeSel: function onchangeSel(n) {
      this.count();
    }
  }
};